import { useNavigate } from 'react-router-dom'
import UsersTable from 'screens/Admin/Users/components/UsersTable'
import Button from 'shared/Buttons/Button/Button'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'

const UsersAdminPage = () => {
  const navigate = useNavigate()

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Пользователи</h2>
          </div>
          <Button theme='primary' style={{ width: 'fit-content' }} onClick={() => navigate('/admin/users/create')}>
            + Создать
          </Button>
        </div>
        <UsersTable onClick={(user) => navigate('/users/' + user.id)} />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default UsersAdminPage
